export interface DirectionsFaq {
  q: string;
  a: string;
}

export interface DirectionsFaqInput {
  companyName: string;
  address: string;
  telephone: string;
  parkcnt: number;
  hasParkinglot: boolean;
  sigunguName: string;
}

export function getDirectionsFaqs({
  companyName,
  address,
  telephone,
  parkcnt,
  hasParkinglot,
  sigunguName,
}: DirectionsFaqInput): DirectionsFaq[] {
  const parkingAnswer =
    parkcnt > 0
      ? `네, 약 ${parkcnt.toLocaleString()}대 규모의 주차장을 운영합니다. 조문 시간대에는 혼잡할 수 있어 가능하시면 대중교통 이용을 권장드립니다.`
      : hasParkinglot
      ? `주차장을 운영하고 있습니다. 정확한 규모와 요금은 현장에서 안내받으시기 바랍니다.`
      : `주차 정보는 사전 확인이 필요합니다. 인근 공영주차장을 함께 확인해 두시면 좋습니다.`;

  return [
    {
      q: `${companyName} 주소는 어디인가요?`,
      a: `주소는 ${address} 입니다. 페이지 상단의 네이버 지도 또는 카카오 지도 버튼을 통해 길찾기를 바로 시작하실 수 있습니다.`,
    },
    {
      q: `${companyName}에 주차할 수 있나요?`,
      a: parkingAnswer,
    },
    {
      q: `${companyName} 전화번호는 어떻게 되나요?`,
      a: telephone
        ? `장례식장 직통 번호는 ${telephone}이며, 빈소 운영 특성상 24시간 응대됩니다. 빈소 위치, 조문 시간, 도착 후 안내가 필요하시면 직접 문의하실 수 있습니다.`
        : `직통 번호는 공개되어 있지 않습니다. 고이 장례식장 정보의 24시간 상담을 통해 문의하실 수 있습니다.`,
    },
    {
      q: `${companyName}은 야간 조문도 가능한가요?`,
      a: `장례식장 특성상 야간 조문이 가능합니다. 다만 자체 운영 정책에 따라 출입 통제가 있을 수 있으니, 늦은 시간 방문 전에는 사전 연락을 권장드립니다.`,
    },
    {
      q: `${sigunguName} 다른 장례식장 정보도 확인할 수 있나요?`,
      a: `네, 같은 지역 ${sigunguName}의 다른 장례식장 찾아가시는 길도 본 페이지 하단에서 함께 확인하실 수 있습니다. 위치, 대중교통, 주차 정보를 비교하시는 데 도움이 됩니다.`,
    },
    {
      q: `${companyName} 빈소 사용료와 장례 비용은 얼마인가요?`,
      a: `빈소별 사용료, 안치료, 입관실 비용 등 장례 전체 예상 비용은 고이 장례식장 정보의 무료 상담을 통해 안내드립니다. 본 페이지 상단·중간·하단의 비용 알아보기 버튼으로 견적을 받으실 수 있습니다.`,
    },
  ];
}
